import { render } from "./HeaderButtons.vue?vue&type=template&id=00325104&scoped=true"
import script from "./HeaderButtons.vue?vue&type=script&lang=ts"
export * from "./HeaderButtons.vue?vue&type=script&lang=ts"

import "./HeaderButtons.vue?vue&type=style&index=0&id=00325104&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-00325104"

export default script